<template>
  <v-container v-if="selectedPlan !== null && selectedPlan !== undefined" fluid grid-list-md>
    <v-dialog scrollable v-model="dialogs.delete" persistent max-width="400">
      <material-card
        v-if="selectedItem"
        :title="$t('views.sidebaritems.delete')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <material-card
      :title="$t('views.sidebaritems.sidebar_items')"
      icon="vertical_split"
      :color="$vuetify.theme.themes.light.secondary"
    >
      <!-- <pbas-data-table
        ref="sidebarItemsTable"
        :dataProvider="sidebarItemProvider"
        :floatActions="sidebarItemActions"
        :rowActions="sidebarItemRowActions"
        :selectActions="sidebarItemSelectActions"
      ></pbas-data-table> -->
      <pbas-data-table
        ref="sidebarItemsTable"
        :dataProvider="sidebarItemProvider"
        :floatActions="sidebarItemActions"
        :rowActions="sidebarItemRowActions"
        :sortBy="'Order'"
        :sortDescending="false"
        @error="error=$event"
      ></pbas-data-table>
    </material-card>

    <v-dialog scrollable v-model="dialogs.edit" max-width="800" persistent>
      >
      <material-card
        :title="$t('views.sidebaritems.edit_sidebar_items')"
        icon="edit"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text v-if="selectedItem">
          <v-form ref="form" v-model="valid">
            <div class="row">
              <div class="col-12 align-self-center">
                <no-autocomplete-textfield
                  type="number"
                  v-model="selectedItem.Order"
                  :label="$t('globals.priority')"
                  :rules="[$rules.requiredInteger]"
                  class="required"
                ></no-autocomplete-textfield>
              </div>
              <div class="col-12 align-self-center">
                <trans-textbox
                  v-model="selectedItem"
                  :label="$t('globals.title')"
                  field="Title"
                  :disabled="false"
                  :rules="[$rules.required]"
                  class="required"
                ></trans-textbox>
              </div>
            </div>
            <div
              v-for="trans of selectedItem.Translations"
              v-bind:key="trans.LanguageCode"
            >
              <div class="row">
                <h5 style="margin-left:5px">{{ trans.LanguageName }}</h5>
              </div>
              <div class="col-md-12 col-xs-12">
                <div class="title">Source</div>
                <image-picker :image.sync="trans.Source"></image-picker>
              </div>
              <div class="col-md-12 col-xs-12">
                <div class="title">Icon</div>
                <image-picker :image.sync="trans.Icon"></image-picker>
              </div>
              <div class="title">Pdf</div>
              <div class="row">
                <div class="col-md-12 col-xs-12" v-if="!trans.Pdf">
                  <file-uploader
                    ref="uploader"
                    :url="uploadUrl"
                    v-on:upload-started="onUploadStarted"
                    v-on:upload-error="onUploadError"
                    v-on:upload-completed="
                      onUploadCompleted($event, trans.LanguageCode)
                    "
                    :autoUpload="true"
                  />
                </div>
                <div
                  class="col-md-12 col-xs-12 align-self-center"
                  v-if="trans.Pdf"
                >
                  <v-row row no-gutters class="flex-nowrap" align="center">
                    <v-col class="col-md-8">
                      <a target="_blank" :href="trans.Pdf.Path + '?attach'">
                        {{ trans.Pdf.Path }}
                      </a>
                    </v-col>
                    <v-col class="col-auto">
                      <v-btn
                        icon
                        @click="
                          trans.Pdf = null;
                          trans.PdfId = undefined;
                        "
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xs-12">
              <v-checkbox
                :label="$t('headers.downloadcategories.allow_guests')"
                v-model="selectedItem.AllowedGuest"
              ></v-checkbox>
            </div>
            <div class="col-12 align-self-center" v-if="classes.length > 0">
              <auto-select
                clear-icon="clear"
                :clearable="true"
                :label="$t('headers.members_management.Class')"
                :value.sync="selectedClass"
                :items="classes"
              ></auto-select>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="clear()" text>{{ $t("globals.cancel") }}</v-btn>
          <v-btn
            :disabled="!formValid()"
            @click="saveSidebarItemHandler"
            :loading="saving"
            color="primary"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import SidebarItemsHeaders from "../headers/SidebarItems";
import TransTextbox from "../components/TransTextbox";
import FileUploader from "../components/FileUploader";
import ImagePicker from "../components/ImagePicker";
import store from "@/store";
import ErrorHandler from "../components/ErrorHandler";
import AutoSelect from "../components/AutoSelect";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import { portalPermission } from "../mixins/portalPermission";
export default {
  components: {
    TransTextbox,
    FileUploader,
    ImagePicker,
    ErrorHandler,
    AutoSelect,
    NoAutocompleteTextfield
  },
  mixins: [planSetter, portalPermission],
  data() {
    return {
      selectedClass: null,
      classes: [],
      error: null,
      dialogs: {
        delete: false,
        edit: false,
      },
      valid: true,
      file: undefined,
      loading: false,
      saving: false,
      sidebarItemProvider: undefined,
      selectedItem: undefined,
      uploadUrl: undefined,
      sidebarItems: [],
      sidebarItemsWithEmpty: [],
      sidebarItemRowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (e) => {
            this.selectedItem = this.deepCopy(e);
            const languages = store.getters["common/languages"];
            for (var l of languages) {
              if (
                !this.selectedItem.Translations.some(
                  (t) => t.LanguageCode == l.language
                )
              ) {
                this.selectedItem.Translations.push({
                  LanguageCode: l.language,
                  LanguageName: l.title,
                });
              } else {
                this.selectedItem.Translations.filter(
                  (t) => t.LanguageCode == l.language
                )[0].LanguageName = l.title;
              }
            }
            if (this.selectedItem.ClassSidebarItem) {
              this.selectedClass = this.selectedItem.ClassSidebarItem.Class;
            } else {
              this.selectedClass = null;
            }
            this.dialogs.edit = true;
            this.$nextTick(() => {
              if (this.$refs.uploader)
                this.$refs.uploader.forEach((u) => u.reset());
            });
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (e) => {
            this.deleteSidebarItemsHandler(e);
          },
        },
      ],
      sidebarItemSelectActions: [
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (e) => {
            this.deleteSidebarItemsHandler(e);
          },
        },
      ],
      sidebarItemActions: [
        {
          name: "Add",
          text: "globals.add_new",
          color: this.$vuetify.theme.themes.light.success,
          icon: "add",
          handler: () => {
            const languages = store.getters["common/languages"];
            this.selectedItem = {
              PlanId: this.selectedPlan.Id,
              Translations: [],
            };
            for (var l of languages) {
              this.selectedItem.Translations.push({
                Title: "",
                LanguageCode: l.language,
                LanguageName: l.title,
              });
            }

            this.selectedClass = null;
            this.dialogs.edit = true;

            this.$nextTick(() => {
              if (this.$refs.uploader)
                this.$refs.uploader.forEach((u) => u.reset());
            });
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("downloadCenter", [
      "getSidebarItems",
      "saveSidebarItem",
      "deleteSidebarItem",
    ]),
    ...mapActions("plansMembers", ["getPlan"]),
    async loadPlanData() {
      this.uploadUrl = this.settings.APIURL + "cms/PhysicalFile/Upload";
      await this.refresh();
    },
    formValid() {
      let valid =
        this.valid &&
        this.selectedItem !== null &&
        this.selectedItem !== undefined;
      if (!valid) return valid;
      for (const trans of this.selectedItem.Translations) {
        valid = trans.Source !== null && trans.Source !== undefined;
        if (!valid) break;
      }
      return valid;
    },
    async refresh() {
      //this.sidebarItems = await this.getSidebarItems(this.selectedPlan.Id);
      this.sidebarItemProvider = new ODataProvider(
        this.$axiosHttp,
        this.settings.APIURL +
          "cms/odata/Plans(" +
          this.selectedPlan.Id +
          ")/SidebarItems",
        SidebarItemsHeaders
      );
      //this.sidebarItemsWithEmpty = [{ Id: "" }, ...this.sidebarItems];
      this.$refs.sidebarItemsTable.selected = [];

      try {
        await this.$refs.sidebarItemsTable.getDataAsync();

        const plan = (await this.getPlan(this.selectedPlan.Id)).data;
        // if (plan && plan.Current.Classes) {

        //   this.classesStr = this.editedItem.Current.Classes.replace(/\[/g, "")
        //     .replace(/\]/g, "")
        //     .replace(/"/g, "");
        // }
        this.classes =
          plan && plan.Current.Classes
            ? JSON.parse(plan.Current.Classes).sort((a, b) => {
                return a.localeCompare(b);
              })
            : [];
        //console.log(JSON.stringify(this.classes));
      } catch (error) {
        this.error = error;
      }
    },
    onUploadCompleted(res, lang) {
      const trans = this.selectedItem.Translations.filter(
        (f) => f.LanguageCode == lang
      )[0];
      trans.PdfId = res.Id;
      trans.Pdf = undefined;
      //for refresh the btn disabled
      // const temp = trans.Source;
      // trans.Source = undefined;
      // trans.Source = temp;

      this.loading = false;
    },
    onUploadStarted() {
      this.loading = false;
    },
    onUploadError() {
      this.loading = false;
    },
    getSidebarItemName(item) {
      if (!item.Translations) {
        return "";
      }
      const lang = store.getters["common/language"].language;
      const filtered = item.Translations.filter((t) => t.LanguageCode == lang);
      return filtered.length > 0 ? filtered[0].Title : "";
    },
    async saveSidebarItemHandler() {
      this.saving = true;
      try {
        for (var trans of this.selectedItem.Translations) {
          delete trans.LanguageName;
          console.log(JSON.stringify(trans))
          if (trans.Source !== null && trans.Source !== undefined) {
            trans.SourceId = trans.Source.Id;
            trans.Source = null;
          }
          if (trans.Icon !== null && trans.Icon !== undefined) {
            trans.IconId = trans.Icon.Id;
            trans.Icon = null;
          }
          if (trans.Pdf !== null && trans.Pdf !== undefined) {
            trans.PdfId = trans.Pdf.Id;
            trans.Pdf = null;
          }
        }
        if (this.selectedClass && this.selectedClass.length > 0) {
          this.selectedItem.ClassSidebarItem = {
            Class: this.selectedClass,
            PlanId: this.selectedPlan.Id
          }
        }
        await this.saveSidebarItem(this.selectedItem);
        this.clear();
        await this.refresh();
      } catch (e) {
        console.error(e);
      } finally {
        this.saving = false;
      }
    },
    async deleteSidebarItemsHandler(item) {
      this.selectedItem = item;
      this.dialogs.delete = true;
    },
    async tryDelete() {
      // if(Array.isArray(items)){
      //   for(var item of items){
      //     await this.deleteSidebarItem(item);
      //   }
      // } else {
      try {
        await this.deleteSidebarItem(this.selectedItem);
        this.dialogs.delete = false;
        // }
        await this.refresh();
      } catch (error) {
        this.error = error;
      }
    },
    deepCopy(inObject) {
      let outObject, value, key;

      if (typeof inObject !== "object" || inObject === null) {
        return inObject; // Return the value if inObject is not an object
      }

      // Create an array or object to hold the values
      outObject = Array.isArray(inObject) ? [] : {};

      for (key in inObject) {
        value = inObject[key];

        // Recursively (deep) copy for nested objects, including arrays
        outObject[key] = this.deepCopy(value);
      }

      return outObject;
    },
    clear() {
      this.selectedItem = undefined;
      this.$refs.form.resetValidation();
      this.dialogs.edit = false;
    },
  },
};
</script>

<style>
.svg-icon svg,
.svg-icon svg path {
  /* fill: #222222 !important;*/
}
</style>
